import React, { useState, useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminProtectedRoute: React.FC = () => {
  const { user, isAdmin, loading, error, adminChecked } = useAuth();
  const location = useLocation();

  if (loading || !adminChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8F8FA]">
        <div className="animate-spin rounded-full h-8 w-8 border-4 border-[#7F56D9] border-t-transparent"></div>
      </div>
    );
  }

  if (!user) {
    console.log('Admin route: no user');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4 bg-[#F8F8FA]">
        <div className="bg-red-50 p-4 rounded-lg text-red-700">{error}</div>
      </div>
    );
  }

  if (!isAdmin) {
    console.log('Admin route: user is not admin, redirecting to dashboard');
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default AdminProtectedRoute;
